import { Spin } from "antd";
import { useEffect, useState } from "react";
import useAdminDataStore, { selectCurrentGroupId, selectAllGroups } from "../../../store/adminData/adminData";
import { withRouter } from "../../../utils/helper";
import AdminContainer from "../admin-container/AdminContainer";

const OurChantsSettings = ({ router }) => {
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const allGroups = useAdminDataStore(selectAllGroups);
  const adminData = allGroups[currentGroup];

  const [isSaving] = useState(false);

  const groupConfig = adminData?.data?.configuration || {};
  let primaryColor = "";
  if (groupConfig.primaryColor) {
    const { r, g, b } = groupConfig.primaryColor;
    primaryColor = `rgb(${r}, ${g}, ${b})`;
  }

  return (
    <AdminContainer>
      <div className="col-md-9">
        <p style={{ fontSize: "20", fontWeight: "bold", marginBottom: 0 }}>
          Chants
        </p>
        <p>
          Publish your chants to a web page and share with fans around the
          stadium who are not part of your group (and not on the Chant app).
        </p>
        <p>
          Your capo can press/hold any chant from the app to send a
          notification and dynamically (in real-time) flip that chant card
          over to show the lyrics. This works for both the app and web.
        </p>
        <p>
          When the web page is accessed via a mobile device we also show a
          card with a link to 'Join' your group. Set the URL to point to your
          chant registration form or your group's website.
        </p>
        <p>
          Chant reserves the right to add Chant and Sponsorship details to
          this page.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>
            Web URL (when published):
          </span>
          {` https://group.chant.fan/${(adminData?.data?.groupName + "").toLowerCase().split(" ").join("")}/chants`}
        </p>
        <div className="align-items-center">
          <span style={{ fontWeight: "bold" }}>
            Setup in the Stadium section of the admin dashboard.
          </span>
        </div>
      </div>
      <div className="d-flex mt-5" style={{ justifyContent: "center" }}>
        <button
          style={{
            backgroundColor: primaryColor,
            borderRadius: 5,
            border: "0px none",
            boxShadow: "transparent 0px 0px 0px",
            outline: "none",
            padding: "5px 10px",
            width: "200px",
          }}
          className="default-text-color"
          onClick={() => router.navigate("/admin/stadium/setup")}
        >
          {isSaving ? (
            <Spin size="small" spinning={true} />
          ) : (
            "Stadium Setup"
          )}
        </button>
      </div>
    </AdminContainer>
  );
};

export default withRouter(OurChantsSettings);
